import React, { FC } from 'react';
import ICtaTextOnlyBox from '../../interfaces/elements/ICtaTextOnlyBox';
import { Column, Columns } from '../base/grid';
import * as StyledCtaTextOnlyBoxes from './ctaTextOnlyBoxes.styles';

interface Props {
	title: string;
	list: ICtaTextOnlyBox[];
}

const CtaTextOnlyBoxes: FC<Props> = ({ title, list }) => {
	return (
		<StyledCtaTextOnlyBoxes.Wrapper>
			<StyledCtaTextOnlyBoxes.Title>{title}</StyledCtaTextOnlyBoxes.Title>
			<Columns>
				{list.map((listItem, index) => (
					<Column tablet={list.length > 1 ? 1 / 2 : 1} key={index}>
						<StyledCtaTextOnlyBoxes.TileWrapper>
							<StyledCtaTextOnlyBoxes.TileTitle>{listItem.Values.Title}</StyledCtaTextOnlyBoxes.TileTitle>
							<StyledCtaTextOnlyBoxes.TileDescription>
								{listItem.Values.Description}
							</StyledCtaTextOnlyBoxes.TileDescription>
							<StyledCtaTextOnlyBoxes.TileLink href={listItem.Values.Link.Url}>
								{listItem.Values.Link.Name}
							</StyledCtaTextOnlyBoxes.TileLink>
						</StyledCtaTextOnlyBoxes.TileWrapper>
					</Column>
				))}
			</Columns>
		</StyledCtaTextOnlyBoxes.Wrapper>
	);
};

export default CtaTextOnlyBoxes;
